import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react'; // Importera useEffect
import Modal from '../components/Modal';
import SectionButton from '../components/SectionButton';
import ReviewsSection from '../components/ReviewsSection.js';

// Define images for the 'Om Oss' gallery. Add your image details here.
// Ensure images are placed in the 'public/images/' folder or a subfolder.
// For an image at 'public/images/gallery/my_photo.jpg', the src would be '/images/gallery/my_photo.jpg'.
const aboutGalleryImages = [
  { src: '/images/omoss/OmOSS1.jpg', alt: 'Beskrivande text för bild 1' },
  { src: '/images/omoss/omsossbror.jpg', alt: 'Beskrivande text för bild 2' },
  { src: '/images/omoss/omossugn1.jpg', alt: 'Beskrivande text för bild 3' },
  { src: '/images/omoss/omosspizza.jpg', alt: 'Beskrivande text för bild 4' },
  { src: '/images/omoss/omossmat.jpg', alt: 'Beskrivande text för bild 5' },
  { src: '/images/omoss/omossugn2.jpg', alt: 'Beskrivande text för bild 6' }
];

// --- NYTT: Definiera förinställningar utanför komponenten eller högst upp ---
const bookingPresets = [
  {
    id: 'birthday_std',
    label: 'Födelsedag',
    icon: '🎂',
    messageText: 'Födelsedagsfirande.',
   
  },
  {
    id: 'birthday_large',
    label: 'Standup (bara med köpt biljett)',
    icon: '🎉',
    messageText: 'Standup.',
    
  },
  {
    id: 'afterwork_small',
    label: 'Afterwork',
    icon: '🍻',
    messageText: 'Afterwork-bokning.',
    
  },
  {
    id: 'family_dinner',
    label: 'Familjemiddag',
    icon: '👨‍👩‍👧‍👦',
    messageText: 'Familjemiddag. Barnstol önskas om tillgängligt.',
 
  },
  {
    id: 'lunch_meeting',
    label: 'Lunchmöte',
    icon: '💼',
    messageText: 'Lunchmöte.',
 
  }
];

const HomePage = ({ navigateTo }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [bookingMessageContent, setBookingMessageContent] = useState('');
  // --- NYTT: State för antalet gäster ---
  const [bookingGuestsCount, setBookingGuestsCount] = useState(''); // Tom sträng för att visa placeholder
  const [selectedImage, setSelectedImage] = useState(null); // State for enlarged image

  const openModal = (modalType) => {
    if (modalType === 'booking') {
      setBookingMessageContent('');
      setBookingGuestsCount(''); // Återställ gästantal när modalen öppnas
    }
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
    setSelectedImage(null); // Also close enlarged image if main modal closes
  }

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  // --- UPPDATERAD: Hantera klick på förinställningar ---
  const handlePresetClick = (preset) => {
    setBookingMessageContent(prevMessage => {
      // Behåll befintlig logik eller anpassa (t.ex. ersätt helt eller lägg till smartare)
      if (prevMessage.includes(preset.messageText)) {
        return prevMessage;
      }
      return prevMessage ? `${prevMessage}, ${preset.messageText}` : preset.messageText;
    });
    // Sätt antalet gäster
  };

  const handleBookingSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const name = formData.get('name');
    const phone = formData.get('phone');
    // --- ANVÄND STATE: Använd bookingGuestsCount för antalet gäster ---
    const guests = bookingGuestsCount || formData.get('guests'); // Fallback om state är tomt, men bör inte vara det om kontrollerat
    const date = formData.get('date');
    const time = formData.get('time');
    const message = bookingMessageContent || 'Inga speciella önskemål.';
    const recipient = 'grande.eslov@hotmail.com'; // grande.eslov@hotmail.com
    const subject = `Bokningsförfrågan från ${name} (${guests} pers)`;
    let body = `Hej Grande,\n\nJag vill göra en bokningsförfrågan:\n\nNamn: ${name}\nTelefon: ${phone}\nAntal personer: ${guests}\nDatum: ${date}\nKlockan: ${time}\n\nÖnskemål:\n${message}\n\nMvh,\n${name}`;
    body = body.replace(/^\s+/gm, '');
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    try {
      window.location.href = mailtoLink;
    } catch (error) {
      console.error("Kunde inte öppna mailto-länk:", error);
    }
    console.log("Försöker öppna e-postklient med förfrågan...");
  };

  const sections = [
    { modalType: null, title: 'Beställ online',subtitle: 'Vid avhämtning bjuder vi på valfri läsk',  icon: '🛒', onClick: () => navigateTo('onlineOrder') },
    { modalType: 'booking', title: 'Boka bord', icon: '📅',},
    { modalType: 'hours', title: 'Öppettider',  icon: '🕒' },
    { modalType: null, title: 'Vår Meny', icon: '📖', onClick: () => navigateTo('onlineMenu') },
    { modalType: 'about', title: 'OM OSS / Galleri', icon: '📷' },
    { modalType: 'contact', title: 'Kontakta oss!', icon: '📞' },
  ];

  const eventDetails = `Måndag - Fredag Lunch 11:30-14:00 `;

  const getModalTitle = (modalType) => {
     switch (modalType) {
       case 'booking': return 'Boka Bord (Förfrågan)';
       case 'hours': return 'Våra Öppettider';
       case 'frozen': return 'FRYST - Ta Med Hem';
       case 'about': return 'Om Oss & Galleri';
       case 'contact': return 'Kontakta Oss';
       case 'catering': return 'Catering';
       case 'review': return 'Lämna en Recension';
       default: return '';
     }
  };

  const renderModalContent = (modalType) => {
     switch (modalType) {
       case 'booking': return (
        <>
          <p className="text-sm text-gray-600 mb-5">
            Fyll i formuläret nedan. När du klickar på knappen öppnas ditt
            e-postprogram med en färdig förfrågan som du sedan skickar till oss.
            Vi återkommer med bekräftelse. <br/>
            <span className="font-medium text-red-700">Populära tider: Kvällar 18:00 - 20:00</span>
          </p>
          <p>Vår email: <strong>grande.eslov@hotmail.com</strong></p>
          <form onSubmit={handleBookingSubmit} className="space-y-5">
            {/* --- START: Förinställda val (Presets) - Flyttad hit --- */}
            <div className="space-y-3 pb-3 border-b border-gray-200 mb-5">
                <label className="block font-medium text-md text-gray-800">
                    Eller välj en snabbförfrågan:
                </label>
                <div className="flex flex-wrap gap-2">
                    {bookingPresets.map((preset) => (
                        <button
                            key={preset.id}
                            type="button"
                            onClick={() => handlePresetClick(preset)}
                            className="flex items-center space-x-2 bg-red-50 hover:bg-red-100 text-red-700 text-sm font-medium py-2 px-3 rounded-lg transition duration-150 border border-red-200 shadow-sm hover:shadow-md"
                        >
                            <span>{preset.icon}</span>
                            <span>{preset.label} </span>
                        </button>
                    ))}
                </div>
            </div>
            {/* --- SLUT: Förinställda val --- */}

            {/* Name and Phone */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="bookingName" className="block mb-1 font-medium text-sm text-gray-700">Namn <span className="text-red-500">*</span></label>
                <input type="text" id="bookingName" name="name" required placeholder="Ditt namn" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"/>
              </div>
              <div>
                <label htmlFor="bookingPhone" className="block mb-1 font-medium text-sm text-gray-700">Telefon <span className="text-red-500">*</span></label>
                <input type="tel" id="bookingPhone" name="phone" required placeholder="070-123 45 67" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"/>
              </div>
            </div>
            {/* Guests, Date, Time */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div>
                <label htmlFor="bookingGuests" className="block mb-1 font-medium text-sm text-gray-700">Antal <span className="text-red-500">*</span></label>
                <input
                  type="number"
                  id="bookingGuests"
                  name="guests"
                  required
                  min="1"
                  placeholder="2"
                  className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"
                  // --- BIND TILL STATE FÖR GÄSTER ---
                  value={bookingGuestsCount}
                  onChange={(e) => setBookingGuestsCount(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="bookingDate" className="block mb-1 font-medium text-sm text-gray-700">Datum <span className="text-red-500">*</span></label>
                <input type="date" id="bookingDate" name="date" required min={new Date().toISOString().split('T')[0]} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"/>
              </div>
              <div>
                <label htmlFor="bookingTime" className="block mb-1 font-medium text-sm text-gray-700">Klockan <span className="text-red-500">*</span></label>
                <input type="text" id="bookingTime" name="time" required className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"/>
              </div>
            </div>

            <div>
              <label htmlFor="bookingMessage" className="block mb-1 font-medium text-sm text-gray-700">Önskemål</label>
              <textarea
                id="bookingMessage"
                name="message"
                rows="3"
                placeholder="T.ex. fönsterbord, allergier..."
                className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50 transition duration-150"
                value={bookingMessageContent}
                onChange={(e) => setBookingMessageContent(e.target.value)}
              />
            </div>
            <div className="pt-4 flex justify-end">
              <button type="submit" className="bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg transition duration-300 shadow-md hover:shadow-lg">
                Skapa E-postförfrågan
              </button>
              
            </div>
            <div className="mb-3 p-3 rounded-lg bg-yellow-50 border-l-4 border-yellow-400 flex items-start">
  <span className="text-yellow-600 mr-2 text-2xl">⚠️</span>
  <div>
    <span className="font-semibold text-yellow-800 block">OBS!</span>
    Vårt svar på din bokningsförfrågan kan ibland hamna i skräppostmappen.
    Kontrollera därför även skräpposten om du inte får svar inom 24 timmar.
  </div>
</div>
          </form>
        </>
       );
       // ... (övriga case-satser för hours, frozen, etc. är oförändrade) ...
       case 'hours': return ( <ul className="space-y-2 list-disc list-inside text-gray-700"> <li><span className="font-semibold">Måndag:</span> 11:30 - 22:00</li> <li><span className="font-semibold">Tisdag:</span> 11:30 - 22:00</li> <li><span className="font-semibold">Onsdag:</span> 11:30 - 22:00</li> <li><span className="font-semibold">Torsdag:</span> 11:30 - 22:00</li> <li><span className="font-semibold">Fredag:</span> 11:30 - 03:00</li> <li><span className="font-semibold">Lördag:</span> 12:00 - 03:00</li> <li><span className="font-semibold">Söndag:</span> 12:00 - 21:00</li> <li className="pt-2 text-sm text-gray-500">Avvikande tider kan förekomma vid helgdagar.</li> </ul> );
       case 'frozen': return ( <div> <h3 className="text-lg font-semibold text-red-800 mb-3">Grande Hemma!</h3> <p className="mb-3">Saknar du vår mat? Nu kan du köpa med dig utvalda favoriter från vår frysdisk!</p> <ul className="space-y-1 list-disc list-inside mb-4"> <li>Färdigbakade frysta pizzor</li> <li>Utvalda färdigrätter (lasagne, cannelloni m.m.)</li> <li>Kylda drycker och tillbehör</li> </ul> <p className="text-sm text-gray-600">Perfekt för en snabb middag eller när du får oväntat besök. Fråga personalen i restaurangen för aktuellt utbud och priser.</p> </div> );
       case 'about': return (
        <div>
    <h3 className="text-lg font-semibold text-red-800 mb-3">
      Välkommen till Grande autentisk Italiensk Restaurang i Eslöv!
    </h3>
    <p  className="mb-4">
      <span style={{background: "linear-gradient(90deg, #009246 33%, #fff 33%, #fff 66%, #ce2b37 66%)", }}  className="font-semibold">Grande</span> är mer än bara en restaurang – det är en levande mötesplats där passion, tradition och italiensk gästfrihet står i centrum. 
      Bakom Grande står två bröder med hjärtat i <span className="font-semibold">Italien</span> och själen i <span className="font-semibold">Eslöv</span>.
      Efter fem års erfarenhet i italienska restauranger och pizzerior tog de sin kunskap och kärlek till det italienska köket hem till Sverige, och öppnade Grande tillsammans.
    </p>
    <p className="mb-4">
      Vår dröm är att ge dig en genuin smak av Italien, med riktigt italienska pizzor bakade i vedugn, klassiska pastarätter och noggrant utvalda råvaror.
      Vi tror på det enkla och goda – äkta italiensk mat, tillagad med stolthet och värme.
    </p>
    <p className="mb-4">
      Hos oss möts du av en familjär stämning där alla ska känna sig välkomna. Kom in och njut av hemlagade rätter, goda viner och en atmosfär som får dig att längta tillbaka till Italien – mitt i hjärtat av Eslöv!
    </p>
    <p className="mb-4">
      <span className="font-semibold">Upplev mer:</span><br />
      Varje vecka bjuder vi på livlig karaoke på fredagar, DJ-kvällar på lördagar och After Work-mys måndag till fredag. Välkommen in till vår italienska oas!
    </p>
    <h4 className="font-semibold text-red-800 mb-2">Galleri</h4>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {aboutGalleryImages.map((image, index) => (
        <img
          key={index}
          src={image.src}
          alt={image.alt}
          className="w-full h-24 object-cover rounded-lg bg-gray-200 cursor-pointer hover:opacity-75 transition-opacity"
          onClick={() => handleImageClick(image.src)}
        />
      ))}
    </div>
    <p className="text-sm text-gray-600 mt-4">
      Se fler bilder på vår{' '}
      <a href="https://www.instagram.com/grande.eslov/" target="_blank" rel="noopener noreferrer" className="text-sm text-red-700 hover:underline mr-4 inline-flex items-center"> <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"> <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.689-.073-4.948-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/> </svg>Instagram</a>
          </p>
  </div> );
       case 'contact': return ( <div className="space-y-6"> <div> <h4 className="font-semibold text-red-800 flex items-center"><span className="mr-2 text-xl">📞</span>Telefon</h4> <a href="tel:041310483" className="text-red-700 hover:underline block mt-1">0413-10 483</a> </div> <div> <h4 className="font-semibold text-red-800 flex items-center"><span className="mr-2 text-xl">📧</span>E-post</h4> <a href="mailto:grande.eslov@hotmail.com" className="text-red-700 hover:underline block mt-1">grande.eslov@hotmail.com</a> </div> <div> <h4 className="font-semibold text-red-800 flex items-center"><span className="mr-2 text-xl">📍</span>Adress</h4> <p className="mt-1">Stora Torg 9<br/>241 30 Eslöv</p> <div className="mt-3 rounded-lg overflow-hidden shadow-md"> <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1883.9015927566843!2d13.302435082872694!3d55.8392549350351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4653952b6ec6f69f%3A0x58923e54f09fe27f!2sStora%20Torg%209%2C%20241%2030%20Esl%C3%B6v!5e0!3m2!1ssv!2sse!4v1747742022724!5m2!1ssv!2sse" width="100%" height="250" style={{ border:0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Karta till Grande Restaurang"></iframe> </div> </div> <div> <h4 className="font-semibold text-red-800 flex items-center mt-2"><span className="mr-2 text-xl">📱</span>Sociala Medier</h4> <div className="mt-1"> <a href="https://www.instagram.com/grande.eslov/" target="_blank" rel="noopener noreferrer" className="text-sm text-red-700 hover:underline mr-4 inline-flex items-center"> <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"> <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.689-.073-4.948-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/> </svg>Instagram</a> <a href="https://www.facebook.com/Granderistorante/" target="_blank" rel="noopener noreferrer" className="text-sm text-red-700 hover:underline inline-flex items-center"><svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"/></svg>Facebook</a> </div> </div> </div> );
       case 'catering': return ( <div> <h3 className="text-lg font-semibold text-red-800 mb-3">Grande Catering - Fest på dina villkor!</h3> <p className="mb-3">Planerar du bröllop, företagsfest, studentfirande eller födelsedagskalas? Låt oss ta hand om maten!</p> <p className="font-semibold mb-1">Vi erbjuder bland annat:</p> <ul className="space-y-1 list-disc list-inside mb-4"> <li>Vår populära Pizza Truck - livebakad pizza på plats!</li> <li>Skräddarsydda bufféer (Italienskt tema eller annat)</li> <li>Antipasti, plockmat och snittar</li> <li>Helhetslösningar med personal och dryck</li> </ul> <p>Kontakta uss för att diskutera dina behov och få en offert:</p> <a href="mailto:grande.eslov@hotmail.com" className="text-red-700 hover:underline font-semibold">grande.eslov@hotmail.com</a> <p className="text-sm text-gray-600 mt-3">Vi ser fram emot att göra ditt event extra speciellt!</p> </div> );
       case 'review': return ( <div> <p className="mb-4">Tack för att du besöker oss! Vi uppskattar verkligen om du vill dela med dig av din upplevelse. Det hjälper både oss och framtida gäster.</p> <p className="font-semibold mb-3">Lämna gärna en recension på:</p> <a href="#" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-4 rounded-lg mb-3 transition duration-200"> Google Reviews [Extern Länk] </a> <a href="#" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-4 rounded-lg transition duration-200"> Tripadvisor [Extern Länk] </a> <p className="text-sm text-gray-600 mt-4">Följ oss gärna på <a href="#" className="text-red-700 hover:underline">Instagram</a> också!</p> </div> );
       default:
         const sectionData = sections.find(s => s.modalType === modalType);
         return <p>Innehåll för "{sectionData?.title || 'denna sektion'}" saknas eller laddas.</p>;
     }
  };

  return (

    <div
      className="container mx-auto px-6 py-10 md:px-12 md:py-14 font-sans"
    >
         <div
               className="container mx-auto px-6 py-10 md:px-12 md:py-14 font-sans"
               style={{
                 minHeight: "333px", // Ensure it takes at least the full viewport height
                 width: "100%",
                 position: "absolute",
                 top: 0,
                 left: 0,
                 right: 0,
                 zIndex: 1,
               }}
          >
           <div
             className="absolute inset-0"
             style={{
               mask: "linear-gradient(360deg, transparent, blue 10%, blue 100%, transparent)",
               WebkitMaskImage: "linear-gradient(360deg, transparent, blue 10%, blue 100%, transparent)",
             }}
           >
             <video
               className="absolute inset-0 w-full h-full object-cover"
               src="/videos/flamma3.mp4"
               autoPlay
               loop
               muted
               playsInline
               preload="auto"
               aria-hidden="true"
             />
             <img
               className="absolute inset-0 w-full h-full object-cover pointer-events-none"
               src="/images/overlayflamma.png"
               alt=""
               aria-hidden="true"
             />
           </div>
           <div className="relative z-10">
     <h1 className="text-5xl md:text-6xl font-serif font-bold text-center text-white drop-shadow-md">
     <span
    style={{
      fontWeight: "bold",
      background: "linear-gradient(90deg, #009246 33%, #fff 33%, #fff 66%, #ce2b37 66%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      display: "inline-block"
    }}
  >
    Grande
  </span>
</h1>
<p className="text-center text-gray-200 mb-6 drop-shadow-sm">
  Wood-fired pizza &amp; Italian kitchen from the{" "}
  <span
  className="font-bold animate-pulse"
  style={{ color: "#a6281f" }}
>
  ❤️
</span>
  {" "}of{" "}

    Napoli
 
  {" "}to the streets of Eslöv!
</p>
         <div
         style={{ opacity: 0.85, zIndex: 2 }}
           className="col-span-2 bg-red-800 text-white p-6 rounded-xl shadow-lg flex flex-col justify-center items-center min-h-[140px] mb-10 md:mb-16 cursor-pointer"
           onClick={() => navigateTo('events')}
         >
           <h2   className="text-2xl text-center font-serif font-bold mb-2">Händer hos oss</h2>
           <p className="text-red-100 text-center">{eventDetails}</p>
           <button onClick={() => navigateTo('events')} className="text-red-100 hover:underline mt-2 inline-block bg-transparent border-none p-0 cursor-pointer">klicka för att se alla evenemang</button>
         </div>
       </div>
      </div>
        <div
        style={{ marginTop: "369px"}} className="grid grid-cols-2 gap-4 md:gap-6">
            {sections.map((section, index) => (
                <SectionButton
                    key={index}
                    title={section.title}
                    subtitle={section.subtitle}
                    icon={section.icon}
                    onClick={section.onClick ? section.onClick : () => openModal(section.modalType)}
                />
            ))}
            
             <div className="col-span-2 bg-green-800 text-white p-6 rounded-xl shadow-lg flex flex-col justify-center items-center text-center min-h-[140px]">
                  <h2 className="text-2xl font-serif font-bold mb-2">ERBJUDANDE</h2>
                  <p className="">🍕 Pizza från 125kr </p>
                  <p className="text-sm text-gray-200">Luftig Krispig Italiensk</p>
                <br></br>
                  <p className="">🍺 Öl Från 50:-</p>
                  <br></br>
                  <p>🍔 Smash burger från 149kr</p>
  <p className="text-sm text-gray-200">Saftig smash burger</p>
                  <h2 className="text-2xl font-serif font-bold mb-2">Välkommen till Grande!</h2>

           </div>
           
            
        </div>
        <ReviewsSection className="/" />
        <Modal
          isOpen={activeModal !== null}
          onClose={closeModal}
          title={getModalTitle(activeModal)}
        >
          {renderModalContent(activeModal)}
        </Modal>

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)} // Close by clicking backdrop
          >
            <div
              className="relative bg-white p-2 rounded-lg shadow-xl max-w-3xl max-h-[90vh]"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on image/container
            >
              <img
                src={selectedImage}
                alt="Enlarged view"
                className="object-contain max-w-full max-h-[85vh] rounded"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1.5 leading-none hover:bg-red-700 transition-colors text-xl"
                aria-label="Close enlarged image"
              >
                &times;
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

export default HomePage;

